'use client';

import React, { useEffect, useState } from 'react';
import styles from './scss/segmentation.module.scss';
import { segmentationNlpLycaDatas } from '../../apiservice/aiLycaPilot';

const TypingText = ({
  text,
  onDone,
  speed = 50,
}: {
  text: string;
  onDone?: () => void;
  speed?: number;
}) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    let i = 0;
    setDisplayedText('');
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, i + 1));
      i++;
      if (i === text.length) {
        clearInterval(interval);
        onDone?.();
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, onDone]);

  // Render typed text with HTML formatting
  return <span dangerouslySetInnerHTML={{ __html: displayedText }} />;
};

const SegMent4 = ({ onComplete }: { onComplete?: () => void }) => {
  const [nlpData, setNlpData] = useState<string | null>(null);

  useEffect(() => {
    const fetchNlpData = async () => {
      try {
        const res = await segmentationNlpLycaDatas();
        if (res?.status === 200) {
          setNlpData(res.data.message); // store API result
        }
      } catch (error) {
        console.error('Error fetching NLP data:', error);
      }
    };
    fetchNlpData();
  }, []);

  return (
    <div className={styles.aisummarysec} style={{maxHeight:'636px'}}>
      <div className={styles.aisummarywrapsec}>
        <h4 className={styles.aisumheading}>AI Summary</h4>

        {nlpData && (
          <div className={styles.aisummarytxt}>
            <TypingText text={nlpData} onDone={onComplete} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SegMent4;
